<template>
  <div :class="$style.clientLogin">
    <Login
      v-show="userState.loginVisible"
      ref="loginRef"
      @redirectRegist="redirectRegist"
      @redirectForget="redirectForget"
      :isClient="true"
      @login="toLogin"
      @redirectArgument="redirectArgument"
    ></Login>
    <Register
      v-if="userState.quickRegisterVisible"
      @redirectLogin="redirectLogin"
      :isClient="true"
      @redirectPhoneRegister="redirectPhoneRegister"
      @register="quickRegister"
      @redirectArgument="redirectArgument"
    ></Register>
    <CellRegister
      v-if="userState.cellRegisterVisible"
      @back="redirectLogin"
      :isClient="true"
      @register="cellRegister"
      @redirectArgument="redirectArgument"
    ></CellRegister>
    <Forgetpswds v-if="userState.resetVisible" @back="redirectLogin" :isClient="true"></Forgetpswds>
    <Affiche v-if="userState.afficheShow" @close="closeAffiche" :isClient="true" :isUseKsSdk="isUseKsSdk"></Affiche>
    <Captcha v-show="userState.captchaVisible" :isClient="true" @captchaInit="captchaInit"></Captcha>
    <Argument v-if="userState.argumentVisible" @redirectRegist="argumentReturn" :isClient="true"></Argument>
    <!-- 防沉迷 -->
    <AntiIndulged v-if="userState.antiIndulgedVisible" @toLogin="antiIndulgedLogin"></AntiIndulged>
    <ForceBindPhone :isClient="true" @close="closeForceBindPhone" v-if="userState.forceBindVisible"></ForceBindPhone>
    <YybLogin v-show="userState.yybLoginVisible"></YybLogin>
    <ForceUpdate v-if="userState.forceUpdateVisible"></ForceUpdate>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { isAndroid, saveAccountList } from '@/libs/utils';
import {
  registJSInitial,
  thirdPartyLogins,
  registLoginVerifySuccessFunction
} from '@/bridge/AppJsBridge';
import { getAccount, setStorage, saveAccount } from '@/libs/utils';
import { CaptchaInit, CaptchaReset } from "@/libs/captcha";
import { activityLink, FLOAT_URL, vipPushLink } from "@/config";

import Login from "@/components/login/Login.vue";
import Register from "@/components/login/Register.vue";
import CellRegister from "@/components/login/CellRegister.vue";
import Forgetpswds from "@/components/login/Forgetpswds";
import Affiche from "@/components/login/Affiche";
import Captcha from "@/components/login/Captcha";
import Argument from "@/components/login/Argument";
import ForceUpdate from '@/components/update/Activity.vue';
import AntiIndulged from './anitiIndulged/antiIndulgedLogin.vue';
import ForceBindPhone from '@/components/login/ForceBindPhone';
import YybLogin from '@/components/login/YybLogin';

export default {
  data() {
    return {
      registerCallback: '', // 暂存滑块验证成功后需要调用的回调方法名
      cellForm: {}, // 手机滑块注册时暂存表单信息
      notifyInfo: {}, // 登录后传给客户端的信息
      isUseKsSdk: false,
      source: 0
    }
  },
  created() {
    /** 处理链接参数、安卓三方平台 */
    this.$store.commit("global/handleLinkParams", this.$route.query);
    this.$store.dispatch("handle/handleClientThirdPlatform", this.$route.query);
  },
  mounted() {
    this._clientInit();
  },
  computed: {
    ...mapState({
      userState: state => state.user,
      globalState: state => state.global,
      captchaStatus: state => state.user.captcha_status
    })
  },
  watch: {
    // // 初始化后监听captcha_status判断当前包是否开启滑块验证
    // captchaStatus(val) {
    //   if (val == '1') {
    //     this._captchaInit();
    //   }
    // }
  },
  components: {
    Login,
    Register,
    CellRegister,
    Forgetpswds,
    Affiche,
    Captcha,
    Argument,
    AntiIndulged,
    ForceBindPhone,
    YybLogin,
    ForceUpdate
  },
  methods: {
    _clientInit() {
      this.$store.commit('global/showLoading')
      registJSInitial(async (e, cb) => {
        const _data = JSON.parse(e);
        this._setUserFromClient(_data.user_list);
        this.$store.commit('user/CHANGE_STATE', {
          device_info: _data.attributeReportParams,
          appkey: _data.jh_app_id,
          channel: _data.jh_channel,
          extra_data: JSON.stringify(_data.extra_data),
          game_version: _data.game_version,
          sdk_version: _data.sdk_version,
          third_sdk_status: _data.third_sdk_status || '', // 这里一定要 || '' ，否则缓存可能存undefined导致支付页出问题
          isEmulator: _data.isEmulator,
          isInstallWeChat: _data.isInstallWeChat,
          isInstallAlipay: _data.isInstallAlipay,
        })
        this.$store.commit('global/clearLoading')

        // 应用宝强制正常登录
        if (_data.third_sdk_status === false) {
          setStorage('force_normal_login', 2);
        }
        // 盒子游戏没安装盒子情况打开正常登录框，记录游戏类型
        if (_data.is_box_game) {
          this.$setStorage('game_type', 'boxGame');
        }
        if (_data.is_wx_box_game) {
          this.$setStorage('game_type', 'wxBoxGame');
        }
        setStorage('is_use_ks_sdk', _data.is_use_ks_sdk); // $$ 快手活动临时
        this.isUseKsSdk = _data.is_use_ks_sdk;
        // 缓存state
        const cacheList = [
          'sdk_version',
          'device_info',
          'appkey',
          'channel',
          'extra_data',
          'game_version',
          'third_sdk_status',
          'isEmulator',
          'isInstallWeChat',
          'isInstallAlipay'
        ];
        await this.$store.dispatch('user/cacheState', cacheList);
        this.$store.dispatch('user/getYsdkStatus');
        this.$store.dispatch('pay/judgePayType');
        this.$store.dispatch('user/affiche');
      });
      thirdPartyLogins((e, cb) => {
        const _data = JSON.parse(e);
        this.$store.commit('user/CHANGE_STATE', { username: _data.user_name, password: _data.origncv });
        saveAccount(_data.user_name, _data.origncv);
        this.toLogin()
      });
    },
    _setUserFromClient(userList) {
      const localList = getAccount();
      if (!userList || (localList && localList.length)) {
        setTimeout(() => {
          this.$refs.loginRef && this.$refs.loginRef.getUserList()
        }, 500)
      } else {
        const list = userList.map(item => {
          return {
            username: item.user_name,
            password: item.password
          }
        })
        saveAccountList(list);
        setTimeout(() => {
          this.$refs.loginRef && this.$refs.loginRef.getUserList()
        }, 500)
      }
    },
    captchaInit() {
      CaptchaInit(
        "captcha",
        (data) => {
          this.$store.commit("user/CHANGE_STATE", { captchaVisible: false });
          CaptchaReset();
          this.registerCallback && this[this.registerCallback](data);
        },
        (err) => {
          CaptchaReset();
          console.log(err);
        }
      );
    },
    redirectRegist() {
      this.$store.commit("user/CHANGE_STATE", {
        loginVisible: false,
        quickRegisterVisible: true,
        argumentVisible: false,
      });
    },
    argumentReturn() {
      switch (this.source) {
        case 0:
          this.$store.commit("user/CHANGE_STATE", {
            loginVisible: true,
            quickRegisterVisible: false,
            argumentVisible: false,
            cellRegisterVisible: false
          });
          break;
        case 1:
          this.$store.commit("user/CHANGE_STATE", {
            loginVisible: false,
            quickRegisterVisible: true,
            argumentVisible: false,
            cellRegisterVisible: false
          });
          break;
        case 2:
          this.$store.commit("user/CHANGE_STATE", {
            loginVisible: false,
            quickRegisterVisible: false,
            argumentVisible: false,
            cellRegisterVisible: true
          });
          break;
        default: 
          this.$store.commit("user/CHANGE_STATE", {
            loginVisible: false,
            quickRegisterVisible: true,
            argumentVisible: false,
            cellRegisterVisible: false
          });
          break;
      }
    },
    redirectForget() {
      this.$store.commit("user/CHANGE_STATE", {
        loginVisible: false,
        resetVisible: true,
      });
    },
    redirectLogin() {
      this.$store.commit("user/CHANGE_STATE", {
        loginVisible: true,
        quickRegisterVisible: false,
        cellRegisterVisible: false,
        resetVisible: false,
      });
    },
    redirectPhoneRegister() {
      this.$store.commit("user/CHANGE_STATE", {
        quickRegisterVisible: false,
        cellRegisterVisible: true,
      });
    },
    redirectArgument(type, source) {
      this.source = source;
      this.$store.commit("user/CHANGE_STATE", {
        quickRegisterVisible: false,
        argumentVisible: true,
        argumentType: type,
      });
    },
    // 快速注册
    async quickRegister() {
      if (this.captchaStatus == "1") {
        // 滑块验证情况
        this.$store.commit("user/CHANGE_STATE", {
          captchaVisible: true,
        });
        this.registerCallback = "captchaQuickRegister";
        return;
      }
      await this.$store.dispatch("user/quickRegister");
      await this.toLogin();
    },
    async cellRegister(form) {
      if (this.captchaStatus == '1') {
        // 滑块验证情况
        this.$store.commit("user/CHANGE_STATE", {
          captchaVisible: true
        });
        this.registerCallback = 'captchaCellRegister';
        this.cellForm = form;
        return;
      }
      await this.$store.dispatch('user/cellRegister', form);
      await this.toLogin();
    },
    async toLogin(form) {
      if (form) {
        const { username, password } = form;
        this.$store.commit("user/CHANGE_STATE", {
          username,
          password,
        });
      }
      const r = await this.$store.dispatch("user/login");
      // 特殊情况
      if (r.content.login_status) {
        this.$store.commit("global/clearLoading");
        return;
      }
      // 登录后强制绑定手机判断
      const { force_bind_tel } = r.content;
      if ([1, 2, 3].includes(force_bind_tel)) {
        // force_bind_tel为2时提示用户绑定手机，但可正常进入游戏
        this.$store.commit("user/CHANGE_STATE", {
          forceBindVisible: true,
        });
        this.$store.commit("global/clearLoading");
        return;
      }
      // 公告
      const { affiche_info } = this.userState;
      if (affiche_info && affiche_info.login_state == 0) {
        return;
      }
      this.handleLoginInfo();
    },
    // 继续处理登录接口返回信息（强制绑定手机成功后也要调用）
    async handleLoginInfo() {
      // vip检查
      await this.$store.dispatch("user/checkVip");
      // 处理登录后通知客户端的信息
      await this.handleNotifyInfo();
      // 防沉迷判断
      this.$store
        .dispatch("user/checkAntiIndulged")
        .then(() => {
          this.$store.commit("user/CHANGE_STATE", {
            antiIndulgedVisible: true,
          });
          this.$store.commit("global/clearLoading");
        })
        .catch(() => this.notifyLoginSuccess());
    },
    // 处理要通知客户端的信息
    async handleNotifyInfo() {
      const { is_vip, vip_type } = this.userState;
      this.notifyInfo = {
        session_id: this.userState.session_id,
        user_id: this.userState.user_id,
        user_name: this.userState.username,
        password: this.userState.password,
        ios_password: this.userState.password,
        login_flag: 1, // 无意义，但不传安卓会报错
        bind_flag: 0, // 无意义，但不传安卓会报错
        bind_status: this.userState.tel_status == 0 ? 1 : 0,
        access_token: this.userState.access_token,
        id_card_status: this.userState.id_card_status,
        force_bind_tel: this.userState.force_bind_tel,
        register_time: this.userState.register_time,
        is_open_activity_url: false, // 已经不用的活动字段，暂存防止客户端异常
        activity_url: "", // 已经不用的活动字段，暂存防止客户端异常
        is_vip: this.userState.is_vip,
        vip_push: vip_type == 2 && is_vip ? vipPushLink : "",
        float_url: FLOAT_URL,
        activityLink,
        menu_list: [], // 安卓兼容处理
        update_gift_url: this.userState.update_gift_status === 1 ? `${window.location.origin}/h5sdk/update-gift` : ""
      };
    },
    // 通知客户端登录成功
    async notifyLoginSuccess() {
      registLoginVerifySuccessFunction(this.notifyInfo);
    },
    closeAffiche() {
      this.$store.commit("user/CHANGE_STATE", {
        afficheShow: false
      });
      const { affiche_info } = this.userState;
      if (affiche_info && affiche_info.login_state == 0) {
        this.$store.commit('global/showLoading');
        this.handleLoginInfo()
      }
    },
    // 防沉迷实名认证后通知客户端登录成功
    antiIndulgedLogin(anti_indulged_info) {
      this.notifyInfo = {
        ...this.notifyInfo,
        anti_indulged_info, // 安卓旧sdk用
        anti_indulged_url: `${window.location.origin}/h5sdk/client/antiIndulged` // 安卓新sdk用
      };
      registLoginVerifySuccessFunction(this.notifyInfo);
    },
    // 关闭强制绑定手机窗口
    closeForceBindPhone(type) {
      const { force_bind_tel } = this.userState
      if (!type && force_bind_tel == 1) {
        this.$store.commit("user/CHANGE_STATE", {
          forceBindVisible: false
        });
      } else {
        this.$store.commit("user/CHANGE_STATE", {
          forceBindVisible: false
        });
        this.$store.commit('global/showLoading');
        this.handleLoginInfo()
      }
    },
    /**
    * 带滑块验证的快速注册
    * @param {Object} validData 滑块验证成功相关信息
    */
    async captchaQuickRegister(validData) {
      await this.$store.dispatch("user/quickRegister", validData);
      await this.toLogin();
    },
    /**
    * 带滑块验证的手机注册
    * @param {Object} validData 滑块验证成功相关信息
    */
    async captchaCellRegister(validData) {
      await this.$store.dispatch("user/cellRegister", { ...this.cellForm, validData });
      await this.toLogin();
    },
  }
}
</script>
<style lang="scss" module>
.clientLogin {
  width: 100%;
  height: 100%;
}
</style>